import { apiGet, apiPatch } from './client';
import type {
  CreditSourceGroupMap,
  CreditSourceGroupMapBatchRequest,
  CreditSourceGroupMapKey,
} from '../types/CreditSourceGroupMap';

function withIdKey(rows: Omit<CreditSourceGroupMap, 'idKey'>[]): CreditSourceGroupMap[] {
  return rows.map((r) => ({ ...r, idKey: `${r.assetTypeId}|${r.balanceTypeId}` }));
}
function stripIdKey(rows: CreditSourceGroupMap[]): Omit<CreditSourceGroupMap, 'idKey'>[] {
  return rows.map(({ idKey, ...rest }) => rest);
}
function parseIdKey(idKey: string): CreditSourceGroupMapKey {
  const [a, b] = idKey.split('|');
  return { assetTypeId: Number(a), balanceTypeId: Number(b) };
}

export async function getCreditSourceGroupMap(): Promise<CreditSourceGroupMap[]> {
  const rows = await apiGet<Omit<CreditSourceGroupMap, 'idKey'>[]>('/api/credit-source-group-map');
  return withIdKey(rows);
}

export async function saveCreditSourceGroupMapBatch(
  added: CreditSourceGroupMap[],
  modified: CreditSourceGroupMap[],
  deletedIdKeys: string[],
): Promise<CreditSourceGroupMap[]> {
  const body: CreditSourceGroupMapBatchRequest = {
    added: stripIdKey(added),
    modified: stripIdKey(modified),
    deleted: deletedIdKeys.map(parseIdKey),
  };
  const fresh = await apiPatch<CreditSourceGroupMapBatchRequest, Omit<CreditSourceGroupMap, 'idKey'>[]>(
    '/api/credit-source-group-map/batch',
    body,
  );
  return withIdKey(fresh);
}
